import styled from 'styled-components';

export const AdvertiserFormStyled = styled.div`
  .advertiserModal {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__rows {
      display: flex;
      flex-direction: column;
      row-gap: 16px;

      .advertiserLogo__container {
        margin-top: 0;
      }

      .singleSelectorComponent {
        &__indicator {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
`;
